export const COOKIE_NAME = 'HL';
export const COOKIE_EXPIRATION_DAYS = 365;
